import * as action from 'actions';
import { call, put, takeLatest, takeEvery } from 'redux-saga/effects';
import * as apiFresh from 'api/fresh';
import * as actFresh from 'actions/fresh';
import * as clevertapFresh from 'clevertap/fresh';

import { PAGE_REQUEST_FRESH, SUBMIT_FORM_FRESH } from 'actions/fresh/constants';

import { showPageLoadingSpinner } from 'actions/loadingSpinner';
import { reset } from 'redux-form';

export function* pageRequest() {
  try {
    clevertapFresh.mokaFreshMenu();
    yield put(action.showProgressBar());
    yield put(showPageLoadingSpinner(true));
    yield call(apiFresh.isEligibleBusiness);
    yield put(actFresh.setIsEligible(true));
  } catch (error) {
    yield put(actFresh.setIsEligible(false));
  } finally {
    yield put(showPageLoadingSpinner(false));
    yield put(action.hideProgressBar());
  }
}

export function* submitFormFresh(request) {
  const { questions } = request.payload;
  clevertapFresh.trackQuestions(questions);
  yield put(actFresh.showModal());
  yield put(reset('mokaFresh'));
}

export default function* freshSaga() {
  yield takeLatest(PAGE_REQUEST_FRESH, pageRequest);
  yield takeEvery(SUBMIT_FORM_FRESH, submitFormFresh);
}
